import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Head from "@/components/Head/index.vue";
import { defineComponent, onMounted, reactive, ref, toRefs } from "vue";
import { validStEnpty } from "@/hooks/validate";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import UpLoadFile from "@/components/UpLoadFile/index.vue";
import Editor from "@/components/Editor/index.vue";
export default defineComponent({
  components: {
    Head: Head,
    UpLoadFile: UpLoadFile,
    Editor: Editor
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var router = useRouter();
    var query = useRoute().query; //表单

    var editorRef = ref(null);
    var uploadRef = ref(null);
    onMounted(function () {
      //编辑回显
      if (query.recordId) {
        getDetail();
      }
    }); //富文本相关

    var editHtml = ref("");
    var editText = ref("");
    var files = []; //编辑回显方法

    function getDetail() {
      return _getDetail.apply(this, arguments);
    } //表单验证


    function _getDetail() {
      _getDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _uploadRef$value;

        var _yield$globalProperti2, data, ids, fileList;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["workselfDetail"]({
                  recordId: query.recordId
                });

              case 2:
                _yield$globalProperti2 = _context2.sent;
                data = _yield$globalProperti2.data;
                ruleForm.title = data.title;
                editorRef.value && editorRef.value["editfun"](data.information); // data.attachment.forEach((element) => {
                //   files.push({
                //     name: element.realName,
                //     id: element.attachmentId
                //   });
                // });

                ids = data.attachmentId;

                if (!(ids != "")) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 10;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getAttachment"]({
                  ids: ids
                });

              case 10:
                fileList = _context2.sent;
                fileList.data.forEach(function (element) {
                  files.push({
                    name: element.realName,
                    id: element.attachmentId
                  });
                });

              case 12:
                (_uploadRef$value = uploadRef.value) === null || _uploadRef$value === void 0 ? void 0 : _uploadRef$value['editFile'](files);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getDetail.apply(this, arguments);
    }

    var ruleForm = reactive({
      title: ""
    });

    var contentPass = function contentPass(rule, value, callback) {
      if (!validStEnpty(ruleForm.title)) {
        callback(new Error("请输入标题"));
      } else {
        callback();
      }
    };

    var rules = {
      title: [{
        required: true,
        validator: contentPass,
        trigger: 'blur'
      }]
    };
    var ruleForms = ref(null);
    var errorflag = ref(false);

    function submitForm() {
      var vaText = validStEnpty(editText.value);
      ruleForms.value && ruleForms.value["validate"]( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var api, attachmentId, obj, _yield$globalProperti, code;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(vaText.length == 0 && files.length == 0)) {
                    _context.next = 4;
                    break;
                  }

                  //富文本和上传附件都没有，不通过
                  errorflag.value = true;
                  _context.next = 19;
                  break;

                case 4:
                  errorflag.value = false;

                  if (!valid) {
                    _context.next = 18;
                    break;
                  }

                  api = "";
                  attachmentId = [];
                  attachmentId = files.map(function (v) {
                    return v["id"];
                  });

                  if (query.recordId) {
                    api = "workselfEdit";
                  } else {
                    api = "workselfAdd";
                  }

                  obj = {
                    information: editHtml.value,
                    title: ruleForm.title,
                    attachmentId: attachmentId.join(",")
                  };
                  _context.next = 13;
                  return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api[api](_objectSpread(_objectSpread({}, obj), {}, {
                    recordId: query.recordId
                  }));

                case 13:
                  _yield$globalProperti = _context.sent;
                  code = _yield$globalProperti.code;

                  if (code == 0) {
                    ElMessage.success("操作成功");
                    setTimeout(function () {
                      router.back();
                    }, 500);
                  } else {
                    ElMessage.error("操作失败");
                  }

                  _context.next = 19;
                  break;

                case 18:
                  return _context.abrupt("return", false);

                case 19:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    } //更改回调


    function filechange(val) {
      files = val;
      tips();
    }

    function editchange() {
      tips();
    } //判断是否显示提示字体


    function tips() {
      var vaText = validStEnpty(editText.value);

      if (vaText.length == 0 && files.length == 0) {
        //富文本和上传附件都没有，不通过
        errorflag.value = true;
      } else {
        errorflag.value = false;
      }
    } //按钮名称


    var submitText = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$btnText.$btn_submit;
    return _objectSpread(_objectSpread({
      files: files,
      submitForm: submitForm,
      ruleForm: ruleForm,
      ruleForms: ruleForms,
      rules: rules
    }, toRefs(ruleForm)), {}, {
      errorflag: errorflag,
      filechange: filechange,
      editHtml: editHtml,
      editText: editText,
      editorRef: editorRef,
      editchange: editchange,
      uploadRef: uploadRef,
      submitText: submitText,
      contentPass: contentPass
    });
  }
});